// extracted by mini-css-extract-plugin
export default {"table_stat":"styles_table_stat__wD7ob","td_select_transparent":"styles_td_select_transparent__7iQvm","td_select":"styles_td_select__JnH1p","active":"styles_active__IOgKj"};